"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
/**
 * useKeyPress
 * @param {string} key - the name of the key to respond to, compared against event.key
 * @param {function} action - the action to perform on key press
 */
const useKeypress = (key, action, listenOnElement, depndency) => {
    (0, react_1.useEffect)(() => {
        function onKeyup(event) {
            if (event.key === key)
                action();
            else if (event.code === key)
                action();
        }
        const keyEventListener = listenOnElement && document.getElementById(listenOnElement) ? document.getElementById(listenOnElement) : window;
        if (typeof window !== "undefined") {
            keyEventListener.addEventListener("keydown", onKeyup, false);
            return () => keyEventListener.removeEventListener("keydown", onKeyup, false);
        }
    }, [depndency]);
};
exports.default = useKeypress;
